import React, { useEffect, useState } from 'react';
import { useHistory, useParams  } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import Errors from '../../components/errors';
import { useUpdateMutation, useGetProjectQuery, useDeleteMutation } from "../../services/projectApi";
import ProjectForm from './project-form';

const EditProject = ({} : any) => {
  let { clientId, projectId } = useParams<any>();
  const [name, setName] = useState('');

  const { data, error, isLoading, isFetching } = useGetProjectQuery( { clientId, projectId });

  const canDelete = data?.canDelete || false;

  const onSetName = (name: string) => {
    setName(name);
  };

  useEffect(() => {
    if (!isLoading) {
      setName(data?.name);      
    }
  },
  [isLoading])

  let history = useHistory();

  const [update, { isLoading: isUpdating, error: updateError }] = useUpdateMutation();
  const [deleteProject, { isLoading: isDeleting, error: deleteError }] = useDeleteMutation();

    const onUpdateProject = (e: any) => {
      e.preventDefault();
      update({clientId, projectId, name})
        .unwrap()
        .then((response: any) => {
          toast.success("Successfully updated project");
          history.push(`/`)  // redirect
        })
        .catch((error) => { toast.error("Error updating project") });
    };

      const onDeleteProject = (e: any) => {
        e.preventDefault();
        confirmAlert({
                title: 'Confirm Delete Project',
                message: `Are you sure you want to delete project? All boreholes and data associated with this project will be deleted.`,
                buttons: [
                  {
                    label: 'Yes',
                    onClick: () => {              
                      deleteProject({clientId, projectId})
                        .unwrap()
                        .then((response: any) => {                          
                          toast.success("Successfully deleted project");              
                          history.push(`/`);
                        })
                        .catch((error: any) => { toast.error("Error deleting project") });
                    }
                  },
                  {
                    label: 'No',
                    onClick: () => {}
                  }
                ]
              });   
      };
 
    return (
      <section className="section">
        <div>
            <h1>Edit Project</h1>
            <Errors error={{...error, ...updateError, ...deleteError}}/>
            <ProjectForm 
                name={name} 
                setName={onSetName} 
                onSaveProject={onUpdateProject} 
                loading={isLoading || isUpdating }  
                canDelete={canDelete}
                onOnDelete={onDeleteProject}
                />
        </div>
      </section>
    )
};

export default EditProject;